import $ from 'jquery';
import { stripTags } from '@/lib/string';

/**
 * Field copier.
 *
 * Usage:
 *   const fieldCopier = new FieldCopier();
 *   fieldCopier.setup(container, from, to);
 *
 */
export default class FieldCopier {
	/**
	 * Maximum length of the copied text
	 */
	maxLength = 32;

	/**
	 * Memory
	 */
	memory = {};

	/**
	 * Copy field content on blur
	 *
	 * @param {String} container
	 * @param {String} from
	 * @param {String} to
	 * @param fromKey
	 * @param toKey
	 * @param rawValue
	 */
	copyOnBlur(container, from, to, fromKey = null, toKey = null, rawValue = false) {
		$(container)
			.find(from)
			.each((index, field) => {
				fromKey = fromKey !== null ? fromKey : from.substr(1);
				toKey = toKey !== null ? toKey : to.substr(1);

				const fromField = $(field);
				const matches = fromField.attr('name').match(new RegExp(`translated\\[${fromKey}\\]\\[([^\\]]+)\\]`));

				// Skip if cannot extract matches
				if (!$.isArray(matches) || matches.length !== 2) {
					return;
				}

				const language = matches[1];
				const toField = $(`[name="translated[${toKey}][${language}]"]`);

				fromField.on('blur', () => {
					if (toField.val() !== '' && toField.val() !== this.memory[language]) {
						return;
					}

					let value = fromField.val();
					value = rawValue ? stripTags(value, true) : value;
					value = value.slice(0, this.maxLength);

					toField.val(value)[0].dispatchEvent(new Event('input'));
					this.memory[language] = value;
				});
			});
	}

	/**
	 * @param {String} container
	 * @param {String} from
	 * @param {String} to
	 * @param fromKey
	 * @param toKey
	 * @param rawValue
	 */
	setup(container, from, to, fromKey = null, toKey = null, rawValue = false) {
		this.copyOnBlur(container, from, to, fromKey, toKey, rawValue);
	}
}
